// A hashtag timeline can also take posts with any of some other tags
// (any), only posts that also have all of some tags (all), and leave out
// posts with some tags (none). The timeline argument carries them after
// the tag: 'art?any=cats,dogs&none=nsfw', each tag encoded as in a URL.

const KINDS = ['any', 'all', 'none']

// '#Cats, dogs #birds' → ['cats', 'dogs', 'birds']; a list of such texts
// (a repeated query key) works too
export const tagList = (text) => [
  ...new Set(
    []
      .concat(text ?? [])
      .join(',')
      .split(/[\s,]+/)
      .map((t) => t.replace(/^#+/, '').toLowerCase())
      .filter(Boolean),
  ),
]

// the argument for a tag and the any/all/none lists of a route query
export const tagArgument = (tag, query = {}) => {
  const parts = KINDS.map((kind) => [
    kind,
    tagList(query[kind]).filter((t) => t !== tag.toLowerCase()),
  ])
    .filter(([, tags]) => tags.length)
    .map(([kind, tags]) => `${kind}=${tags.map(encodeURIComponent).join(',')}`)
  return parts.length ? `${encodeURIComponent(tag)}?${parts.join('&')}` : tag
}

export const parseTagArgument = (argument) => {
  const at = argument.indexOf('?')
  if (at === -1) return { tag: argument, any: [], all: [], none: [] }
  const query = new URLSearchParams(argument.slice(at + 1))
  return Object.fromEntries([
    ['tag', decodeURIComponent(argument.slice(0, at))],
    ...KINDS.map((kind) => [
      kind,
      (query.get(kind) ?? '').split(',').filter(Boolean),
    ]),
  ])
}

export const isCombined = (argument) => (argument ?? '').includes('?')
